import { render } from "./AutocompleteText.vue?vue&type=template&id=1ef626c3"
import script from "./AutocompleteText.vue?vue&type=script&lang=js"
export * from "./AutocompleteText.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__